import { observable, action } from "mobx";

class Store {
    @observable state = false;
    @observable name = "";

    @action
    onChange = (state) => {
        this.state = state;
    }
}

const compared = new Store();

export default compared;


// WEBPACK FOOTER //
// ./src/store/compared.js